import { MetricsServiceError } from './types'

/**
 * Maps an axios failure onto the legacy error contract — RESOLVE, never reject.
 * The two messages are user-facing strings; changing them is a copy change.
 */
export function toServiceError(error: { code?: string }): MetricsServiceError {
  if (error !== undefined && error.code !== undefined && error.code === 'ECONNABORTED') {
    return {
      err_code: 'ECONNABORTED',
      err_message:
        'A request timeout occured. Please refresh your page and try again. Contact us if error persists.',
    }
  }

  return {
    err_code: 'ERR',
    err_message:
      'We encountered an error. Please refresh your page and try again. Contact us if error persists.',
  }
}

export default toServiceError
